import React from 'react'
import { func, string, oneOfType, object, bool } from 'prop-types'
import { useIntl } from 'react-intl'
import Icon from '../components/ui/icon/Icon'
import Typeahead from '../components/ui/typeahead/Typeahead'
import { DEFAULT_FUNC, EMPTY_OBJECT } from '../utils/constants'
import { isAbleToSearchWithoutText } from '../helpers/common'
import { searchBarMessages as messages } from './messages'
import { messages as aggregationNames } from '../components/aggregations/messages'

const DEFAULT_MESSAGE = { ...messages.default }

const SearchBar = ({
  handleInput,
  placeholder = '',
  query,
  onSearch,
  placeholderValue = EMPTY_OBJECT,
  suggestions,
  aggregationActive,
  onSuggestionSelected = DEFAULT_FUNC,
  clearQuery,
  isInnerSearch = false
}) => {
  const intl = useIntl()
  const defaultPlaceholder = intl.formatMessage({ ...messages.all })
  const searchPlaceholder = intl.formatMessage({ ...messages.search })
  const aggregation = aggregationActive ? intl.formatMessage({ ...aggregationNames[aggregationActive] }) : ''
  const noResultsMessage = intl.formatMessage({ ...messages.noResults }, { type: aggregation })
  const formattedPlaceholder = placeholder && intl.formatMessage({ ...DEFAULT_MESSAGE, ...placeholder }, { ...placeholderValue })

  const handleSearchWithoutText = () => {
    if (isAbleToSearchWithoutText(aggregationActive) || query.trim() !== '') {
      onSearch(query)
    }
  }
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearchWithoutText()
    }
  }

  const renderInput = (value, onChange, onKeyDown, onIconClick = DEFAULT_FUNC) => (
    <div className='afd-nav__search__searchfield searchbar-container'>
      <Icon svg='search' onClick={onIconClick} />
      <input
        autoFocus
        autoComplete='off'
        className='afd-nav__search__input js-afd-search-focus searchbar-input'
        id='searchbar-input'
        name='text'
        onChange={onChange}
        onKeyDown={onKeyDown}
        placeholder={placeholder && placeholder !== messages.all
          ? searchPlaceholder + ' ' + formattedPlaceholder
          : defaultPlaceholder
        }
        type='search'
        value={value}
      />
      {query && clearQuery && <Icon svg='cancel' onClick={clearQuery} />}
    </div>
  )

  if (suggestions) {
    return <Typeahead
      suggestions={suggestions}
      noResultsMessage={noResultsMessage}
      onSuggestionSelected={onSuggestionSelected}>
      {renderInput}
    </Typeahead>
  }

  return (
    <div className={`afd-search-actions ${isInnerSearch ? 'afd-search-actions--inner-search' : ''}`}>
      {renderInput(query, handleInput, handleKeyPress, () => onSearch(query))}
    </div>
  )
}

SearchBar.propTypes = {
  handleInput: func.isRequired,
  onSearch: func,
  clearQuery: func,
  query: string,
  placeholder: oneOfType([string, object]),
  placeholderValue: object,
  aggregationActive: string,
  suggestions: object,
  onSuggestionSelected: func,
  isInnerSearch: bool
}

export default SearchBar
